import React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import Slider from 'react-slick'
import Markdown from '@/components/common/Markdown'
import { useDispatch, useSelector } from 'react-redux'
import { getFilters, setFilters } from '@/store/slices/speakersSlice'

const RelatedSpeakers = ({ speakerData, setIsLoading, makeRelatedSpeakers }) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const filters = useSelector(getFilters)

  const handleRedirect = (slug) => {
    setIsLoading(true)
    dispatch(setFilters({ ...filters, relatedSpeakers: makeRelatedSpeakers(slug) }))
    const url = `/speaker/${slug}`
    router.push(url)
  }

  return (
    <>
      {speakerData?.map((speaker, index) =>
        speaker?.relatedSpeakers?.length !== 0 ? (
          <div className="m-auto mb-16 lg:mt-16" key={index}>
            <div className="w-full sm:px-0">
              <div className="flex flex-wrap md:flex-row md:px-1 md:items-center md:space-x-8 md:text-sm md:font-thin">
                <h1 className="py-4 mt-6 text-2xl tracking-wide text-white uppercase tagline-font md:mt-4 md:pr-2 px-2 xs:px-0">
                  Related Speakers
                </h1>
              </div>
              <div>
                <div className="invisible maxMobile:visible absolute maxXs:h-[300px] z-50 right-0 w-24 gradient-black2"></div>
              </div>
              {speakerData?.map((speaker, i) =>
                speaker?.relatedSpeakers?.length >= 4 ? (
                  <Slider {...relatedSpeakersSettings} key={i}>
                    {speakerData?.map((speaker) =>
                      speaker?.relatedSpeakers?.map((item, i) => (
                        <div
                          className="flex-1 gap-4 p-2 cursor-pointer group"
                          key={i}
                          onClick={() => handleRedirect(item.slug)}
                        >
                          <Link
                            href={`/speaker/${item?.slug}`}
                            key={item?.slug}
                            passHref
                            legacyBehavior
                          >
                            <a>
                              {item?.assets?.fields?.file?.url !== undefined ? (
                                <div
                                  className="mb-2 homepage-speaker-profile-img"
                                  style={{
                                    backgroundImage: `url(${
                                      'https:' + item?.assets?.fields?.file?.url
                                    }?fm=webp&w=290&h=395&q=100&fit=thumb&f=top&q=100)`,
                                    backgroundPosition: 'center top',
                                    backgroundSize: 'cover',
                                  }}
                                ></div>
                              ) : (
                                <div
                                  className="mb-2 homepage-speaker-profile-img"
                                  style={{
                                    backgroundImage: `url(https://images.ctfassets.net/p6iqoqavudao/3lLPw0ct3NWRdllJaozgZr/238aa02d0b3a99038d1969146d7916f1/placeholder.png?fm=webp&w=290&h=395&q=100&fit=thumb&f=top&q=100)`,
                                    backgroundPosition: 'center top',
                                    backgroundSize: 'cover',
                                  }}
                                ></div>
                              )}
                            </a>
                          </Link>
                          <div
                            className="pt-4 mr-3 text-left cursor-pointer text-md group-hover:link-underline"
                            onClick={() => handleRedirect(item.slug)}
                          >
                            <h5>
                              <a>{item?.name}</a>
                            </h5>
                          </div>
                          {item?.subline && (
                            <div
                              className="w-11/12 text-xs font-normal text-left cursor-pointer text-md text-custom-gray-90 group-hover:text-white"
                              onClick={() => handleRedirect(item.slug)}
                            >
                              <Markdown data={item?.subline} />
                            </div>
                          )}
                        </div>
                      ))
                    )}
                  </Slider>
                ) : (
                  <>
                    {/* visible in all screen except mobile  */}
                    <div className="maxSm:h-[0] maxSm:w-[0] maxSm:invisible">
                      <Slider {...lessRelatedSpeakersSettings}>
                        {speakerData?.map((speaker) =>
                          speaker?.relatedSpeakers?.map((item, i) => (
                            <>
                              <div
                                className="flex-1 gap-4 p-2 cursor-pointer group"
                                key={i}
                                onClick={() => handleRedirect(item.slug)}
                              >
                                <Link href="javascript:;" legacyBehavior>
                                  <a href={`/speaker/${item?.slug}`}>
                                    {item?.assets?.fields?.file?.url !== undefined ? (
                                      <div
                                        className="mb-2 homepage-speaker-profile-img"
                                        style={{
                                          backgroundImage: `url(${
                                            'https:' + item?.assets?.fields?.file?.url
                                          }?fm=webp&w=290&h=395&q=100&fit=thumb&f=top&q=100)`,
                                          backgroundPosition: 'center top',
                                          backgroundSize: 'cover',
                                        }}
                                      ></div>
                                    ) : (
                                      <div
                                        className="mb-2 homepage-speaker-profile-img"
                                        style={{
                                          backgroundImage: `url(https://images.ctfassets.net/p6iqoqavudao/3lLPw0ct3NWRdllJaozgZr/238aa02d0b3a99038d1969146d7916f1/placeholder.png?fm=webp&w=290&h=395&q=100&fit=thumb&f=top&q=100)`,
                                          backgroundPosition: 'center top',
                                          backgroundSize: 'cover',
                                        }}
                                      ></div>
                                    )}
                                  </a>
                                </Link>
                                <div className="pt-4 mr-3 text-left text-md group-hover:link-underline">
                                  <h5>
                                    <a>{item?.name}</a>
                                  </h5>
                                </div>
                                {item?.subline && (
                                  <div className="w-11/12 text-xs font-normal text-left text-md text-custom-gray-90 group-hover:text-white">
                                    <Markdown data={item?.subline} />
                                  </div>
                                )}
                              </div>
                            </>
                          ))
                        )}

                        {[
                          ...Array(
                            4 - speakerData?.map((speaker) => speaker?.relatedSpeakers?.length)
                          ),
                        ].map((item, index) => (
                          <div
                            className="hidden lg:flex-1 lg:p-2 lg:gap-4 md:flex-1 md:p-2 md:gap-4"
                            key={index}
                          >
                            <div className="relative hidden mb-2 mr-3 xl:h-96 xl:w-92 h-72 w-92"></div>
                            <div className="hidden mr-3 text-justify cursor-pointer text-md"></div>
                            <div className="hidden text-xs font-normal text-justify text-md opacity-60"></div>
                          </div>
                        ))}
                      </Slider>
                    </div>

                    {/* visible only in mobile  */}
                    <div className="invisible minXs:h-[0] minXs:w-[0] maxSm:visible">
                      <Slider {...lessRelatedSpeakersSettings}>
                        {speakerData?.map((speaker) =>
                          speaker?.relatedSpeakers?.map((item, i) => (
                            <>
                              <div className="flex-1 gap-4 p-2 cursor-pointer group" key={i}>
                                <Link href="javascript:;" legacyBehavior>
                                  <a href={`/speaker/${item?.slug}`}>
                                    {item?.assets?.fields?.file?.url !== undefined ? (
                                      <div
                                        className="mb-2 homepage-speaker-profile-img"
                                        style={{
                                          backgroundImage: `url(${
                                            'https:' + item?.assets?.fields?.file?.url
                                          }?fm=webp&w=290&h=395&q=100&fit=thumb&f=top&q=100)`,
                                          backgroundPosition: 'center top',
                                          backgroundSize: 'cover',
                                        }}
                                      ></div>
                                    ) : (
                                      <div
                                        className="mb-2 homepage-speaker-profile-img"
                                        style={{
                                          backgroundImage: `url(https://images.ctfassets.net/p6iqoqavudao/3lLPw0ct3NWRdllJaozgZr/238aa02d0b3a99038d1969146d7916f1/placeholder.png?fm=webp&w=290&h=395&q=100&fit=thumb&f=top&q=100)`,
                                          backgroundPosition: 'center top',
                                          backgroundSize: 'cover',
                                        }}
                                      ></div>
                                    )}
                                  </a>
                                </Link>
                                <div
                                  className="pt-4 mr-3 text-left text-md group-hover:link-underline"
                                  onClick={() => handleRedirect(item.slug)}
                                >
                                  <h5>{item?.name}</h5>
                                </div>
                                {item?.subline && (
                                  <div
                                    className="w-11/12 text-xs font-normal text-left text-md text-custom-gray-90 group-hover:text-white"
                                    onClick={() => handleRedirect(item.slug)}
                                  >
                                    <Markdown data={item?.subline} />
                                  </div>
                                )}
                              </div>
                            </>
                          ))
                        )}

                        {speakerData && speakerData.length > 0 ? (
                          [
                            ...Array(
                              (speakerData[0]?.relatedSpeakers?.length >= 4
                                ? 4
                                : speakerData[0]?.relatedSpeakers?.length) -
                                speakerData?.map((speaker) => speaker?.relatedSpeakers?.length)
                            ),
                          ].map((item, index) => (
                            <div
                              className="hidden lg:flex-1 lg:p-2 lg:gap-4 md:flex-1 md:p-2 md:gap-4"
                              key={index}
                            >
                              <div className="relative hidden mb-2 mr-3 xl:h-96 xl:w-92 h-72 w-92"></div>
                              <div className="hidden mr-3 text-justify cursor-pointer text-md"></div>
                              <div className="hidden text-xs font-normal text-justify text-md opacity-60"></div>
                            </div>
                          ))
                        ) : (
                          <div></div>
                        )}
                      </Slider>
                    </div>
                  </>
                )
              )}
            </div>
          </div>
        ) : (
          <></>
        )
      )}
    </>
  )
}

const lessRelatedSpeakersSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  initialSlide: 0,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 2,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        infinite: true,
        dots: false,
        centerPadding: '20%',
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        swipeToSlide: true,
        centerMode: true,
        centerPadding: '20%',
      },
    },
  ],
}

function NextArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        content: 'url(/static/icons/right-arrow.svg) !important',
        height: '25px !important',
        top: '45%',
      }}
      onClick={onClick}
    />
  )
}

function PrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        content: 'url(/static/icons/left-arrow.svg) !important',
        height: '25px !important',
        top: '45%',
      }}
      onClick={onClick}
    />
  )
}
const relatedSpeakersSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  initialSlide: 0,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 2,
        arrows: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        infinite: true,
        dots: false,
        centerPadding: '20%',
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        swipeToSlide: true,
        centerMode: true,
        centerPadding: '20%',
      },
    },
  ],
}
export default RelatedSpeakers
